import { ThemeTokens } from '@acp/core-ui';
import {
    ModalBody,
    Spinner,
    Text,
    VStack,
} from '@chakra-ui/react';

function AccessIssuesWizardLoadingScreen({
    description,
}: {
    description: string;
}) {
    return (
        <ModalBody px={ThemeTokens.TenancyModal.body.py}>
            <VStack alignItems="center" py={10} gap={4} h="100%">
                <Spinner />
                <Text>
                    { description }
                </Text>
            </VStack>
        </ModalBody>
    );
}

export { AccessIssuesWizardLoadingScreen };
